(function () {  
   function initCartUpsellSwiper(root) {
     if (typeof Swiper === 'undefined') return;

     var context = root || document;
     var upsellSwiperEl = context.querySelector('.cart-drawer-upsell-swiper');
     if (!upsellSwiperEl || upsellSwiperEl.dataset.swiperInitialized === 'true') return;

     upsellSwiperEl.dataset.swiperInitialized = 'true';

     new Swiper(upsellSwiperEl, {
       // Base value; refined per breakpoint below
       slidesPerView: 1.2,
       spaceBetween: 16,
       loop: false,
       navigation: {
         nextEl: '.cart-drawer-upsell-next',
         prevEl: '.cart-drawer-upsell-prev',
       },
       pagination: {
         el: '.cart-drawer-upsell-pagination',
         clickable: true,
       },
       observeParents: true,
       observer: true,
       resizeObserver: true,
       breakpoints: {
         // Small mobile
         0: {
           slidesPerView: 1.2,
         },
         // Larger mobile / small tablet
         480: {
           slidesPerView: 1.3,
         },
         // Tablet and up
         768: {
           slidesPerView: 1.35,
         },
         // Desktop and larger
         1024: {
           slidesPerView: 1.4,
         },
       },
     });
   }

   function resetCartDrawerUpsellLayout() {
     document.querySelector('#CartDrawer #cart-drawer-upsell')?.remove();

     const wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper');
     if (!wrapper) return;

     const items = wrapper.querySelector('cart-drawer-items');
     if (items && wrapper.parentNode) {
       wrapper.parentNode.insertBefore(items, wrapper);
     }
     wrapper.remove();
   }

   async function syncCartDrawerUpsellWrapper() {
     const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper');
     if (!currentWrapper) return;

     const response = await fetch(window.location.href);
     const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
     const freshWrapper = doc.querySelector('#cart-drawer-upsell-wrapper');
     if (freshWrapper) {
       currentWrapper.replaceWith(freshWrapper);
     }
   }

   function insertSectionCartDrawer() {
      if (
        document.querySelector('#CartDrawer .cart-drawer-items-wrapper') &&
        document.querySelector('#CartDrawer #cart-drawer-upsell')
      ) {
        return;
      }

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      if (!upsells) return

      wrapper.insertAdjacentHTML('afterend', upsells.innerHTML)
      initCartUpsellSwiper(wrapper.parentNode)
      initCartUpsellVariantDatasets()
 
      if (!document.querySelector('#CartDrawer .cart-drawer-upsell-list li')) {
        document.querySelector('#CartDrawer #cart-drawer-upsell')?.remove()
      }
    }

    async function refreshCartDrawerUpsell() {
      await syncCartDrawerUpsellWrapper();
      resetCartDrawerUpsellLayout();
      insertSectionCartDrawer();
    }

    window.refreshCartDrawerUpsell = refreshCartDrawerUpsell;

    refreshCartDrawerUpsell()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    function syncCartUpsellProductFormData(select) {
      if (!select) return
      const form = select.closest('product-form')
      if (!form) return
      const opt = select.options[select.selectedIndex]
      if (!opt) return
      if (opt.dataset.currencyAmount != null && opt.dataset.currencyAmount !== '') {
        form.setAttribute('data-currency-amount', opt.dataset.currencyAmount)
        const btn = form.querySelector('.cart-drawer-upsell-add-btn')
        if (btn) btn.setAttribute('data-currency-amount', opt.dataset.currencyAmount)
      }
      if (opt.dataset.productId) {
        form.setAttribute('data-product-id', opt.dataset.productId)
        const btn = form.querySelector('.cart-drawer-upsell-add-btn')
        if (btn) btn.setAttribute('data-product-id', opt.dataset.productId)
      }
    }

    function initCartUpsellVariantDatasets() {
      document
        .querySelectorAll('select.cart-drawer-upsell-variant-select')
        .forEach((sel) => syncCartUpsellProductFormData(sel))
    }

    window.onChangeKsUpsellVariantSelector = function (select, event) {
      event.preventDefault()
      const item = select.closest('.cart-drawer-upsell-list-item')
      if (!item) return

      const opt = select.options[select.selectedIndex]
      const imgSrc = opt && opt.dataset && opt.dataset.variantImg

      if (imgSrc) {
        const img =
          item.querySelector('.cart-drawer-upsell-image img') ||
          item.querySelector('.cart-drawer-upsell-list-item-left img')
        if (img) img.src = imgSrc
      }

      syncCartUpsellProductFormData(select)
    }

    initCartUpsellVariantDatasets()

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.cart-drawer-upsell-add-btn')
      if (!btn) return

      const form = btn.closest('form')
      if (!form) return

      e.preventDefault()
      e.stopPropagation()

      if (btn.dataset.loading === 'true') return
      btn.dataset.loading = 'true'
      btn.setAttribute('disabled', 'disabled')

      const variantId = form.querySelector('[name="id"]').value
      const cartDrawer = document.querySelector('cart-drawer')
      const sections = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map(s => s.id)
        : []

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections }),
      })
        .then(r => r.json())
        .then(data => {
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data)
          }
        })
        .catch(err => console.error('Upsell add to cart failed', err))
        .finally(() => {
          btn.dataset.loading = 'false'
          btn.removeAttribute('disabled')
        })
    })

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(() => {
          refreshCartDrawerUpsell().catch((err) => {
            console.error('Failed to refresh cart drawer upsell', err);
          });
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();